// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"611":"9f12cae6","707":"557b7037"}[chunkId] + ".chunk.css";
};